export interface HorizonsConfig {
  dossierBaseUrl: string;
}
